import React from 'react';

import {useI18n} from '@udemy/i18n';

import styles from './bento-messaging-module.module.less';
import {BENTO_VISUAL_CONFIG} from './bento-visual-config';
import {getBentoTiles} from './fixtures';
import {MessagingBanner, type MessagingBannerVisual} from './messaging-banner.react-component';

const DEFAULT_VISUAL: MessagingBannerVisual = {backgroundStyle: {}};

export const BentoMessagingModule = () => {
    const {gettext} = useI18n();
    const [large, ...stacked] = getBentoTiles(gettext);

    return (
        <div className={styles.grid} data-purpose="bento-messaging-module">
            <div className={styles.large} data-purpose="messaging-banner-slot" data-slot="large">
                <MessagingBanner
                    tile={large}
                    visual={BENTO_VISUAL_CONFIG[large.trackingId] ?? DEFAULT_VISUAL}
                />
            </div>
            <div className={styles.stack}>
                {stacked.map((tile) => (
                    <div
                        key={tile.trackingId}
                        className={styles.stacked}
                        data-purpose="messaging-banner-slot"
                        data-slot="stacked"
                    >
                        <MessagingBanner
                            tile={tile}
                            visual={BENTO_VISUAL_CONFIG[tile.trackingId] ?? DEFAULT_VISUAL}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};
